import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollToTop from "@/components/ScrollToTop";
import LandingPage from "@/pages/LandingPage";
import CheckoutPage from "@/pages/CheckoutPage";
import SuccessPage from "@/pages/SuccessPage";
import ServicesPage from "@/pages/ServicesPage";
import BookingPage from "@/pages/BookingPage";
import BookingThanksPage from "@/pages/BookingThanksPage";
import ConsultationPage from "@/pages/ConsultationPage";
import GroupClassPage from "@/pages/GroupClassPage";
import RequestThanksPage from "@/pages/RequestThanksPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AuthCallback from "@/pages/AuthCallback";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import WaitlistPage from "@/pages/WaitlistPage";
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogPostPage from "@/pages/BlogPostPage";
import GalleryPage from "@/pages/GalleryPage";

export default function App() {
  const location = useLocation();
  // Synchronous detection of #session_id=... before normal routing
  if (location.hash?.includes("session_id=")) {
    return (
      <div className="min-h-screen bg-gg-bg text-[var(--gg-text)]">
        <Toaster position="top-center" richColors />
        <AuthCallback />
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-gg-bg text-[var(--gg-text)]">
      <ScrollToTop />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/register/:classId" element={<CheckoutPage />} />
        <Route path="/success/:registrationId" element={<SuccessPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/booking-thanks/:bookingId" element={<BookingThanksPage />} />
        <Route path="/consultation" element={<ConsultationPage />} />
        <Route path="/group-class" element={<GroupClassPage />} />
        <Route path="/request-thanks/:requestId" element={<RequestThanksPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/waitlist/:classId" element={<WaitlistPage />} />
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
      </Routes>
    </div>
  );
}
